import React from "react";
import IconSvg from "./IconSvg";
import "./style.css";

const PerformanceOutliersCard = ({ data, onViewAllStudents }) => {
  const { topPerformers, bottomPerformers, actionRequiredInsight } = data;
  // console.log("topperformer", topPerformers)
  return (
    <div className="lg-col-span-4 card p-4">
      <div className="flex justify-between items-start mb-3">
        <span className="font-medium text-gray-800">Performance Outliers</span>
        <div className="tooltip-wrapper">
          <IconSvg
            path="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            className="h-3-5 w-3-5 text-gray-400"
          />
          <div className="tooltip-content w-48">
            Top and bottom performing students in the batch based on assessment
            scores.
          </div>
        </div>
      </div>

      {/* Top Performers */}
      <div className="mb-3">
        <h4 className="flex items-center text-xs font-medium text-gray-700 mb-1.5">
          <IconSvg
            path="M5 11l7-7 7 7M5 19l7-7 7 7"
            className="h-3-5 w-3-5 mr-1 text-green-500"
          />
          Top 5 Students
          <div className="tooltip-wrapper">
            <IconSvg
              path="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              className="h-3-5 w-3-5 text-gray-400"
            />
            <div className="tooltip-content w-48">
              Students with the highest overall scores on the employability
              assessment, indicating strong career readiness.
            </div>
          </div>
        </h4>
        <div className="space-y-1">
          {topPerformers.map((student) => (
            <div key={student.user_id} className="outlier-list-item top-performer">
              <div className="outlier-profile-pic-wrapper">
                {student.profilePicUrl ?
                  <img
                    src={student.profilePicUrl}
                    alt={student.name}
                    className="outlier-profile-pic"
                  /> :
                  <div className="outlier-profile-pic-placeholder">
                    {student.name.charAt(0).toUpperCase()}
                  </div>
                }
              </div>
              <div className="outlier-details">
                <div className="flex justify-between items-center">
                  <span className="outlier-name">{student.name}</span>
                  <span className="outlier-score top-performer">
                    {student.score}%
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Performers */}
      <div>
        <h4 className="flex items-center text-xs font-medium text-gray-700 mb-1.5">
          <IconSvg
            path="M19 13l-7 7-7-7m14-8l-7 7-7-7"
            className="h-3-5 w-3-5 mr-1 text-red-500"
          />
          Bottom 5 Students
          <div className="tooltip-wrapper">
            <IconSvg
              path="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              className="h-3-5 w-3-5 text-gray-400"
            />
            <div className="tooltip-content w-48">
              Students with the lowest scores who need targeted intervention and
              skill development support.
            </div>
          </div>
        </h4>
        <div className="space-y-1">
          {bottomPerformers.map((student) => (
            <div
              key={student.user_id}
              className="outlier-list-item bottom-performer"
            >
              <div className="outlier-profile-pic-wrapper">
                {student.profilePicUrl ?
                  <img
                    src={student.profilePicUrl}
                    alt={student.name}
                    className="outlier-profile-pic"
                  /> :
                  <div className="outlier-profile-pic-placeholder">
                    {student.name.charAt(0).toUpperCase()}
                  </div>
                }
              </div>
              <div className="outlier-details">
                <div className="flex justify-between">
                  <span className="outlier-name">{student.name}</span>
                  <span className="outlier-score bottom-performer">
                    {student.score}%
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-3 pt-2 border-t border-gray-100">
        <p className="text-sm text-gray-600">
          <span className="font-medium text-indigo-600">Action Required:</span>{" "}
          {actionRequiredInsight}
        </p>
        <div className="view-all-button-wrapper">
          <button
            onClick={() => onViewAllStudents()}
            className="view-all-button"
          >
            <IconSvg
              path="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
              className="view-all-button-icon"
            />
            View all students
          </button>
        </div>
      </div>
    </div>
  );
};

export default PerformanceOutliersCard;
